import { useCallback } from 'react'

import {
  Dashboardv99990101Api,
  dashboardv99990101Client
} from '@sequencehq/api/dashboard/v99990101'

export type v1ApiNewProduct = Dashboardv99990101Api.PostProduct.ProductBody & {
  id: string
}

type UseSaveProducts = () => {
  createProducts: (newProducts: v1ApiNewProduct[]) => Promise<
    {
      temporaryId: string
      realId: string | null
    }[]
  >
}

export const useSaveProducts: UseSaveProducts = () => {
  const createProducts = useCallback(async (newProducts: v1ApiNewProduct[]) => {
    const response = await Promise.all(
      newProducts.map(({ label, ...product }) =>
        dashboardv99990101Client
          .postProduct({
            body: {
              label: label ?? undefined,
              name: product.name,
              taxCategoryId: product.taxCategoryId
            }
          })
          .then(result => {
            if (result.error) {
              return {
                temporaryId: product.id,
                realId: null
              }
            }

            return {
              temporaryId: product.id,
              realId: result.data?.id ?? null
            }
          })
      )
    )

    return response
  }, [])

  return {
    createProducts
  }
}
